
import React from 'react'
import { DialogContent, DialogHeader, Dialog, DialogTitle } from '../../dialog_md'
interface FormPopupProps {
    open: boolean;
    setOpen?: (val: boolean) => void
    children?: React.ReactNode
}
const Modal_md = ({ open, setOpen, children }: FormPopupProps) => {

    return (

        <Dialog open={open} onOpenChange={setOpen} >
            <DialogContent className="w-[100%] flex flex-col items-center px-2 border border-border_primaryDarkBlue z-9999" 
            onPointerDownOutside={(event) => event.preventDefault()}>
            <DialogTitle></DialogTitle>
                {children}
            </DialogContent>
        </Dialog>

    )
}

export default Modal_md
